import React from "react";
import { Link } from "gatsby";
import Layout from "../components/Layout";
import Seo from "../components/SEO";
import Ad from "../components/Ad";
import TableOfContents from "../components/TableOfContents";

const SocialMediaTemplates = ({ location }) => {
  return (
    <Layout location={location}>
      <Seo
        title="+60 Free Social Media Templates (2023)"
        description="Looking to create stunning content for Social Media? Start with these free social media templates for the most popular social media networks in the world. Including facebook, linkedin, twitter and many more"
        pathname="social-media-templates"
      />
      <div className="slim-container md-page">
        <TableOfContents />
        <div className="section" id="1">
          <div className="md-head">
            <h1>+60 Free Social Media Templates</h1>
            <span className="author">
              By&nbsp;
              <a
                href="http://twitter.com/assentorp"
                target="_blank"
                rel="noreferrer"
              >
                Peter Assentorp
              </a>
            </span>
            <img
              src={require(`../images/social-media-templates.jpg`).default}
              alt="Social Media Templates"
            />
          </div>
          <p>
            Welcome to socialsizes.io the biggest source for free social media
            templates. Here you will find templates for the most popular social
            networks in the world. Our missions is to be the best source for
            designers and creators to get their content for social done faster.
            Currently we offer templates for <b>14</b> networks with <b>60</b>{" "}
            templates in total.
          </p>
          <Ad />
          <p>
            The templates are made for the most popular design tools today. So
            you must own a copy of either: Sketch, Figma, Adobe XD or Adobe
            Photoshop to take advantage of them. The prices for some of these
            design tools can be a bit pricy for beginners. We recommend using{" "}
            <b>Figma</b> as it's <u>free</u> and runs in your browser. That
            means that you don't have to have a big expensive computer to get
            started with the social media templates.
          </p>
          <p>
            Social media templates are pre-designed graphics or layouts that can
            be used to create social media posts or ads. These templates
            typically include placeholder text and images, as well as design
            elements such as fonts, colors, and logos, that can be customized to
            create a unique and branded social media post. There are many
            different types of social media templates available for Facebook,
            including templates for posts, ads, events, and more. Using a social
            media template can help to save time and ensure that your posts are
            visually consistent and professionally designed. Some popular tools
            for creating social media templates for Facebook include Canva,
            Adobe Spark, and Crello.
          </p>
        </div>
        <div className="section" id="1-1">
          <img
            src={require(`../images/facebook-banner-size.jpg`).default}
            alt="Facebook banner size"
          />
          <h2>Social Media Templates for Facebook</h2>
          <p>
            Want to create a new cover photo for you facebook page? or maybe
            create a new ad campaign for your business? The first thing you
            would usually do is to open your design tool. The next thing you
            would probably be asking yourself is: what size should you make this
            new photo or video in?
          </p>
          <p>Don't worry we got you.</p>
          <p>
            You can find all the sizes and social media templates for facebook
            you need by clicking the button below. Just select what network you
            would like sizes from. In this case you would pick facebook. Then
            just choose your desired design tool and the download will begin
            immediately. In seconds you will have the social media template for
            facebook up and running.
          </p>
          <Link to="/" className="button orange">
            <svg
              width="20"
              height="20"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
              />
            </svg>
            <span>Download free templates</span>
          </Link>
        </div>
        <div className="section" id="1-2">
          <img
            src={require(`../images/linkedin-cover-photo-size.jpg`).default}
            alt="LinkedIn cover photo size"
          />
          <h2>Social Media Templates for LinkedIn</h2>
          <p>
            What is the size for linkedin posts? what's the size for linkedin
            banners? What about the profile background? Yes, we have all been
            there. It's super hard to find the <b>correct sizes</b> to use for
            LinkedIn. Often images will get cropped or displayed incorrectly.
            When this happens important text on your image could be hidden. The
            best and only way to avoid this is to use the correct dimensions.
          </p>
          <p>
            These dimensions are often hidden somewhere in a help center. A
            horrible experience. You just want you business page or profile to
            look good right? Well, the way you do this is to use a template for
            LinkedIn. I personally make sure that all the sizes are up-to-date,
            so you don't have to worry about your content being cropped.
          </p>
          <p>
            Learn more about the{" "}
            <Link to="/linkedin-cover-photo-size/">
              LinkedIn Cover Photo Size
            </Link>{" "}
            here
          </p>
          <p>
            Should it be the case that your content gets cropped - please don't
            hesitate to contact me. I do my best to keep this site up to date -
            but it can be quite hard with all the changes happening on all
            platforms. Anyways, you can find all sizes and social media
            templates for linkedin by clicking the button below and clicking the
            "LinkedIn" icon.
          </p>
          <Link to="/" className="button orange">
            <svg
              width="20"
              height="20"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
              />
            </svg>
            <span>Download free templates</span>
          </Link>
        </div>
        <div className="section" id="1-3">
          <img
            src={require(`../images/twitter-cover-photo-size.jpg`).default}
            alt="Twitter cover photo size"
          />
          <h2>Social Media Templates for Twitter</h2>
          <p>
            What is the <b>twitter post size</b> you might be wondering? Yes,
            it's a mess to figure out. Often when you post something on Twitter
            half the image will get cropped. So why does this happen? Quite
            often it's because your using the wrong image size or dimensions.
          </p>
          <p>
            The best way to make sure your content will look good is to use our
            free social media templates for twitter. The are always up to date
            with the latest sizes. Yes but how will you know if a size has
            changed? In the top of this page you'll find a form field where you
            can put in your email address. When you hit "Get notified". You'll
            be on the list for updates to any size or dimensions used in the
            templates.
          </p>
          <p>
            So next time you won't be creating a twitter post size that's using
            the old sizes. You'll always know when to go download a new template
            for your next twitter post. To get the templates just hit the button
            below and click the twitter logo. You'll be scrolled to the twitter
            section automatically and can select which design tool you want
            templates for.
          </p>
          <Link to="/" className="button orange">
            <svg
              width="20"
              height="20"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
              />
            </svg>
            <span>Download free templates</span>
          </Link>
        </div>
        <div className="section" id="1-4">
          <h2>Twitch Image Sizes</h2>
          <img
            src={require(`../images/twitch-cover-photo-size.jpg`).default}
            alt="Facebook cover photo size"
          />
          <p>
            Okay, so you've created your Twitch account and you are now looking
            for ways to make your channel stand out from the rest. One way to do
            that is to have a great cover photo and profile picture or avatar as
            Twitch calls it. On SocialSizes we have the templates you need to
            get started. All you need is either Sketch, Photoshop, Figma or
            Adobe XD. So first, go download one of these applications.
          </p>
          <div className="section" id="1-4-1">
            <h3>Twitch profile picture</h3>
            <p>
              The twitch profile picture is very important and really make you
              stand out from the rest. Most users on twitch either choose a real
              image of themselves or a personal logo. Both have pros and cons...
              but if you are just starting out I'd highly recommend you{" "}
              <b>go with just a picture of yourself</b>. Nobody trusts or wants
              to see a person without a face - that's also why the most popular
              streamers are those where you can actually see the person
              streaming. (Another good reason to get a webcam if you don't own
              one).
            </p>
            <p>
              If you have gained traction you can start to incorperate a
              "personal branding" logo for your channel. A good example of a
              streamer doing this is <b>BreaK</b>. He uses a bear as a logo that
              is easily recognizable.
            </p>
            <p>
              Ready to get started? In the template for Twitch a bit further
              down you'll find the perfect size to use for your profile picture.
              Just download the free template below to get started.
            </p>
          </div>
          <div className="section" id="1-4-2">
            <h3>Twitch cover image and header size</h3>
            <p>
              Looking to create a cover image for your twitch channel. Then look
              no further. We got the template you need. All you have to do is to
              download the free template below. You do that by clicking the
              button and clinking on the Twitch logo. Different design tool
              options will appear. Just click the design tool you want to use,
              open the file and get started with your masterpiece. It's that
              simple.
            </p>
          </div>
          <Link to="/" className="button orange">
            <svg
              width="20"
              height="20"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
              />
            </svg>
            <span>Download free templates</span>
          </Link>
        </div>
        <div className="section" id="1-5">
          <h2>How to make good content for Social Media</h2>
          <img
            src={
              require(`../images/how-to-make-good-content-for-socialmedia.jpg`)
                .default
            }
            alt="How to make good content for socialmedia"
          />
          <p>
            Alright, so you've downloaded the social media templates and your
            ready to get started creating your next image or video. Now you
            might be thinking how do you make this post or piece of content so
            good that people want to click / engage with it. It's actually not
            that hard if you follow these three simple rules.
          </p>
          <div className="section" id="1-5-1">
            <h3>1. Get peoples attention</h3>
            <p>
              In the social media landscape it can be quite tricky to get
              peoples attention. Nonetheless that's the first step to create a
              great post on social. With images think simple and straight to the
              point. Don't overuse colors and text. <b>Keep it simple</b>. With
              video make sure your first 1-2 seconds has something that draw
              people in. It could be a product that slides in from the side or
              something that blinks. People have it wired in their brains to pay
              attention to things that move.
            </p>
          </div>
          <div className="section" id="1-5-2">
            <h3>2. Keep it short. Use simple words.</h3>
            <p>
              People don't read long sentences unless it's a really great and
              captivating story. So first of all, write for skimming. That
              means, shorten your sentences. Use simple words that aren't hard
              to read. Don't use buzzwords unless your target audience is very
              familiar with them. Add statistics or numbers that support your
              copy - people love numbers. According to research by conductor
              headlines with numbers are{" "}
              <b>36% more likely to generate clicks</b>. That's a lot more
              clicks. Last but not least. Use more periods. It makes everything
              easier to read.
            </p>
          </div>
          <div className="section" id="1-5-3">
            <h3>3. Test, test. test.</h3>
            <p>
              Create. Post. Measure. <b>Repeat</b>. It's that simple. You might
              not get it right the first time. No one usually will. You have to
              test and figure out what works and then make what works even
              better.
            </p>
            <p>
              To sum up: It’s more important than ever that you monitor your
              brand and keep in touch with your audience. Start by creating
              quality content. Then post that content across all of your social
              media platforms, just as you would a blog. Measure what's
              happening and use that information to create even better content
              next time around.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SocialMediaTemplates;
